export enum UserOptions {
	Company = "Empresas",
	News = "Novedades",
	Contacts = "Contactos",
	Documents = "Documentos",
}
